import { type Conversation } from 'entities/Conversation'
import { isOptOutCurrentInbox } from 'entities/Contacts'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export const hasOpenFilter = (conversation: Conversation, entities: IEntitiesStore) => {
  if (conversation.isStarted && !conversation.contact?.isOptOut && !conversation.isClosed) {
    return true
  }

  return (
    conversation.isStarted &&
    !isOptOutCurrentInbox({
      contact: conversation.contact,
      conversation: conversation,
      entities: entities,
    }) &&
    !conversation.isClosed
  )
}
